require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2003-10-01-copyright-this.json") })
        }
      }, "path---articles-2003-10-01-copyright-this");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2003-10-01-copyright-this!./.cache/json/articles-2003-10-01-copyright-this.json
// module id = 334
// module chunks = 231608221292675